module.exports = __webpack_public_path__ + "static/media/VISA_MC@3x.21d37fd4.png";